import { LanaEnvService } from '../env';
import { BaseRouting } from '@aipb/routing';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LanaRouting extends BaseRouting {
  static APP_ROUTE = 'lana';
  static configPath = ':configId';
  static schemaPath = 'schema';
  static schemaDefaultPath = ':id';

  private _schemaDefault: string[] = [LanaRouting.schemaPath, LanaRouting.schemaDefaultPath];

  constructor(lanaEnv: LanaEnvService) {
    super(['/' + LanaRouting.APP_ROUTE, LanaRouting.configPath], lanaEnv);
  }

  schemaDefault(id: string, configId: string = this.getConfigId()): void {
    this.nav(this._schemaDefault, {
      id,
      configId
    });
  }

  schemaDefaultAbsUrl(id: string, configId: string = this.getConfigId()): string {
    return this.absUrl(this._schemaDefault, {
      id,
      configId
    });
  }

  schemaDefaultRouteUrl(id: string, configId: string = this.getConfigId()): string {
    return this.routeUrl(this._schemaDefault, {
      id,
      configId
    });
  }
}
